function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { componentsThemeMap, colorToVariable } from '../../componentsThemeMap.js';
import { ANALYTICS_KEY } from '../../constants.js';
import '../../ui/Div/index.js';
import { LinkButton } from '../../ui/Link/LinkButton.js';
import '../../ui/RichText/index.js';
import { createListRichTextOptions } from '../../ui/RichText/options/listRichTextOptions.js';
import { Text } from '../../ui/Text.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { RichText } from '../../ui/RichText/RichText.js';
const customComponentThemeMap = {
  default: _objectSpread(_objectSpread({}, componentsThemeMap.default), {}, {
    elevation: 1
  }),
  dark: _objectSpread(_objectSpread({}, componentsThemeMap.dark), {}, {
    background: 'foregroundMuted',
    foreground: 'primaryForeground',
    foregroundSecondary: 'primaryForeground',
    elevation: 0
  }),
  subtle: _objectSpread(_objectSpread({}, componentsThemeMap.subtle), {}, {
    elevation: 1
  }),
  wash: _objectSpread(_objectSpread({}, componentsThemeMap.wash), {}, {
    elevation: 1
  }),
  darkwash: _objectSpread(_objectSpread({}, componentsThemeMap.darkwash), {}, {
    elevation: 1
  }),
  primary: _objectSpread(_objectSpread({}, componentsThemeMap.primary), {}, {
    elevation: 1
  })
};
function ComparisonCard({
  title,
  subtitle,
  description,
  listTitle,
  list,
  ctaLabel,
  ctaUrl,
  style = 'default',
  listStyle
}) {
  const _customComponentTheme = customComponentThemeMap[style],
    background = _customComponentTheme.background,
    foreground = _customComponentTheme.foreground,
    foregroundSecondary = _customComponentTheme.foregroundSecondary,
    elevation = _customComponentTheme.elevation,
    borderLine = _customComponentTheme.borderLine;
  return /*#__PURE__*/jsxs(Div, {
    gap: 4,
    background: background,
    elevation: elevation,
    spacing: {
      sm: 2,
      md: 5
    },
    flexDirection: "column",
    borderRadius: "roundedSmall",
    justifyContent: "space-between",
    height: "100%",
    maxWidth: 400,
    css: {
      borderColor: colorToVariable(borderLine || 'line')
    },
    children: [/*#__PURE__*/jsxs(Div, {
      flexDirection: "column",
      justifyContent: "space-between",
      flex: 1,
      children: [/*#__PURE__*/jsx(Text, {
        as: "span",
        spacingTop: 1,
        variant: {
          sm: 'title4',
          md: 'title2'
        },
        color: foregroundSecondary,
        flex: 1,
        children: title
      }), /*#__PURE__*/jsx(Text, {
        as: "span",
        color: foreground,
        spacingTop: 1,
        variant: "headline",
        flex: 1,
        children: subtitle
      }), /*#__PURE__*/jsx(Text, {
        as: "p",
        variant: "body",
        spacingTop: 1,
        color: foregroundSecondary,
        children: description
      })]
    }), /*#__PURE__*/jsxs(Div, {
      flexDirection: "column",
      justifyContent: "space-between",
      flex: 1,
      children: [/*#__PURE__*/jsx(Text, {
        as: "span",
        color: foreground,
        spacingTop: 1,
        variant: "headline",
        flex: 1,
        children: listTitle
      }), list && /*#__PURE__*/jsx(Div, {
        css: {
          display: 'contents',
          p: {
            color: colorToVariable(foregroundSecondary)
          }
        },
        children: /*#__PURE__*/jsx(RichText, {
          content: list,
          richTextOptions: createListRichTextOptions(listStyle, foregroundSecondary),
          color: foregroundSecondary
        })
      })]
    }), /*#__PURE__*/jsx(Div, {
      alignItems: "center",
      flex: 1,
      css: {
        div: {
          flex: 1,
          button: {
            flex: 1
          }
        }
      },
      children: ctaLabel && ctaUrl && /*#__PURE__*/jsx(Div, {
        alignSelf: "flex-end",
        children: /*#__PURE__*/jsx(LinkButton, {
          href: ctaUrl,
          variant: "secondary",
          "data-qa": ANALYTICS_KEY.ComparisonCardCTA,
          children: ctaLabel
        })
      })
    })]
  });
}
export { ComparisonCard };
//# sourceMappingURL=ComparisonCard.js.map
